export interface InquiryToCustomer {
  id: number;
  createdBy: string;
  createdByFullname: string;
  product: string;
  productId: number;
  status: InquiryToCustomerStatus;
  statusText: string;
  inquiryType: "documents" | "appointment" | "information" | "informationAndDocuments" | "decision" | "link";
  overdueConsequences: string | null;
  inquiryTextAppointment: string | null;
  inquiryTextAppointmentCustomer: string | null;
  inquiryTextInformation: string | null;
  inquiryTextDocuments: string | null;
  inquiryTextDocumentsCustomer: string | null;
  inquiryTextCustomer: string | null;
  inquiryTextInformationCustomer: string | null;
  inquiryDecisionQuestion: string | null;
  inquiryDecisionAnswer: string | null;
  deadline: string;
  requestedDocuments: Array<any>;
  calendlyEvent: string | null;
  identifier: string | null;
  created: string;
  updated: string;
  doneBy: string;
  createFollowUpActivity: boolean;
  hideInquiryTextDocumentsCustomer: boolean;
  feedbackRecipient: string;
  customerId: number;
  config: string;
  linkUrl: string;
  attachedMediaObjects: Array<number> | null;
}

export enum InquiryToCustomerStatus {
  STATUS_OPEN = 10,
  STATUS_IN_PROGRESS = 20,
  STATUS_OVERDUE = 30,
  STATUS_DONE = 40,
}
